<template>
  <div class="m-1">
    <div v-html="campaign.custom_message"></div>
    <h3 class="text-blue">{{$t('campaigns.Description')}}</h3>
    <div ref="overview" v-html="campaign.description"></div>
    <div v-for="(custom_field, index) in custom_fields" :key="index">
      <h3 class="text-blue">{{custom_field.front_name}}</h3>
      <div v-html="custom_field.form_value"></div>
    </div>
  </div>
</template>

<script>
import { getDatev2 } from "@/libs/utils/times";

export default {
  name: 'tabOverview',
  props: {
    campaign: {
      required: true,
      type: Object,
    }
  },
  data() {
    return {
      custom_fields: []
    }
  },
  created() {
    const only_custom_fields = this.campaign.custom_fields.filter(custom => {
      return custom.type_field === null && custom.show_link
    })
    this.custom_fields = this.orderCustomFields(only_custom_fields)
  },
  methods: {
    getFormatDate(date) {
      return getDatev2(new Date(date))
    },
    orderCustomFields(custom_fields) {
      custom_fields.sort(function(a, b) {
        return a.order - b.order;
      });
      return custom_fields
    },
  }
};
</script>

<style>
.text-blue {
  color: #4b22f4;
}
</style>
